export default {
  ERROR_ENV: 'Environment failure',
} as const;
